
    <template>
      <section class="content element-doc">
        <h2>Apex Navigator 产品地图</h2>
<p>产品地图公共组件</p>
<h3>基本用法</h3>
<p>传入的参数</p>
<demo-block>
        <div><p>传入 <code>env</code> 参数来确定是什么环境，<code>env</code> 参数可选值为 <code>test</code> <code>uat</code> <code>prod</code> 分别对应 测试、UAT和生产环境。还需要传入<code>ajaxParams</code>参数，来调用统计接口记录，具体参数可见下方属性：</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button type=&quot;primary&quot; @click=&quot;handleClickShow&quot; style=&quot;margin-bottom: 20px&quot;&gt;点击显示组件&lt;/el-button&gt;
&lt;apex-navigator ref=&quot;refApexNavigator&quot; env=&quot;test&quot; :probability=&quot;20&quot; :ajaxParams=&quot;ajaxParams&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        ajaxParams: {
          systemCode: 'xc-export-hkg', // 必填，表示源系统code
          sourceUrl: 'https://ehkgtest.apexworkflow.com', // 必填，表示跳转时源系统地址
          account: 'TEST.HKG', // 必填，表示跳转时的操作人
          accountCompany: 'APEX-HKG' // 必填，表示跳转时操作人的所属office
        }
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>显示概率</h3>
<p>设置初始化显示的概率值</p>
<demo-block>
        <div><p>传入 <code>probability</code> 参数来设置初始化显示的概率值，可选值为 <code>0</code> 到 <code>100</code>，数值越大概率越高，默认为 <code>50</code>。</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button type=&quot;primary&quot; @click=&quot;handleClickShow&quot; style=&quot;margin-bottom: 20px&quot;&gt;点击显示组件&lt;/el-button&gt;
&lt;apex-navigator ref=&quot;refApexNavigator&quot; env=&quot;test&quot; :probability=&quot;100&quot; :ajaxParams=&quot;ajaxParams&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        ajaxParams: {
          systemCode: 'xc-export-hkg', // 必填，表示源系统code
          sourceUrl: 'https://ehkgtest.apexworkflow.com', // 必填，表示跳转时源系统地址
          account: 'TEST.HKG', // 必填，表示跳转时的操作人
          accountCompany: 'APEX-HKG' // 必填，表示跳转时操作人的所属office
        }
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>固定定位</h3>
<p>让组件固定定位在浏览器右上角</p>
<demo-block>
        <div><p>传入 <code>env</code> 参数来确定是什么环境，<code>env</code> 参数可选值为 <code>test</code> <code>uat</code> <code>prod</code> 分别对应 测试、UAT和生产环境。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button type=&quot;primary&quot; @click=&quot;handleClickShow&quot; style=&quot;margin-bottom: 20px&quot;&gt;点击显示组件&lt;/el-button&gt;
&lt;el-button type=&quot;danger&quot; @click=&quot;handleClick&quot; style=&quot;margin-bottom: 20px&quot;&gt;固定定位切换&lt;/el-button&gt;
&lt;apex-navigator ref=&quot;refApexNavigator&quot; env=&quot;test&quot; :probability=&quot;90&quot; :top=&quot;top&quot; /&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        top: ''
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      },
      handleClick() {
        if (this.top) {
          this.top = ''
        } else {
          this.top = '66px'
        }
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>env</td>
<td>当前环境</td>
<td>string</td>
<td>test/uat/prod</td>
<td>—</td>
</tr>
<tr>
<td>top</td>
<td>当传入top时,组件变为固定定位，固定在右上角，top的值可根据自身项目填写合适的px</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>probability</td>
<td>设置初始化显示的概率值</td>
<td>number</td>
<td>0-100</td>
<td>50</td>
</tr>
<tr>
<td>ajaxParams</td>
<td>记录点击操作日志，具体接口参数见下方 AjaxParams Options</td>
<td>object</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>AjaxParams Options</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>systemCode</td>
<td>必填，表示源系统code</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>sourceUrl</td>
<td>必填，表示跳转时源系统地址</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>account</td>
<td>必填，表示跳转时的操作人</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>accountCompany</td>
<td>必填，表示跳转时操作人的所属office</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>confirm</td>
<td>点击查看跳转时的回调</td>
<td>—</td>
</tr>
<tr>
<td>show</td>
<td>组件显示时的回调</td>
<td>—</td>
</tr>
<tr>
<td>hide</td>
<td>组件隐藏时的回调</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>Methods</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>show</td>
<td>手动让组件显示</td>
<td>—</td>
</tr>
<tr>
<td>hide</td>
<td>手动让组件隐藏</td>
<td>—</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"primary"},on:{"click":_vm.handleClickShow}},[_vm._v("点击显示组件")]),_vm._v(" "),_c('apex-navigator',{ref:"refApexNavigator",attrs:{"env":"test","probability":20,"ajaxParams":_vm.ajaxParams}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        ajaxParams: {
          systemCode: 'xc-export-hkg', // 必填，表示源系统code
          sourceUrl: 'https://ehkgtest.apexworkflow.com', // 必填，表示跳转时源系统地址
          account: 'TEST.HKG', // 必填，表示跳转时的操作人
          accountCompany: 'APEX-HKG' // 必填，表示跳转时操作人的所属office
        }
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"primary"},on:{"click":_vm.handleClickShow}},[_vm._v("点击显示组件")]),_vm._v(" "),_c('apex-navigator',{ref:"refApexNavigator",attrs:{"env":"test","probability":100,"ajaxParams":_vm.ajaxParams}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        ajaxParams: {
          systemCode: 'xc-export-hkg', // 必填，表示源系统code
          sourceUrl: 'https://ehkgtest.apexworkflow.com', // 必填，表示跳转时源系统地址
          account: 'TEST.HKG', // 必填，表示跳转时的操作人
          accountCompany: 'APEX-HKG' // 必填，表示跳转时操作人的所属office
        }
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"primary"},on:{"click":_vm.handleClickShow}},[_vm._v("点击显示组件")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"danger"},on:{"click":_vm.handleClick}},[_vm._v("固定定位切换")]),_vm._v(" "),_c('apex-navigator',{ref:"refApexNavigator",attrs:{"env":"test","probability":90,"top":_vm.top}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        top: ''
      };
    },
    methods: {
      handleClickShow() {
        this.$refs.refApexNavigator.show()
      },
      handleClick() {
        if (this.top) {
          this.top = ''
        } else {
          this.top = '66px'
        }
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  